import module from 'app/module.js'
import template from './template.html'

class AppExcelImportarAyudaComponent {
  constructor () {
    this.onClose = null
  }
}

module.component('appExcelImportarAyuda', {
  controller: AppExcelImportarAyudaComponent,
  template,
  bindings: {
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/excel/importar/ayuda/component.js